import { COLOURS } from '@belong/themes';
import styled from 'styled-components';

import { Spinner } from '@belong/ui-components/components/feedback/LoadingSpinner/LoadingSpinner.styles';

export const StatusWrapper = styled.div`
  padding: 1.6rem;
`;

const size = '2.4rem';
const borderWidth = '0.3rem';

export const UploadSpinner = styled(Spinner)`
  width: ${size};
  height: ${size};
  border-width: ${borderWidth};
  border-color: ${COLOURS.WHITE} ${COLOURS.BELONG_BLUE} ${COLOURS.BELONG_BLUE};

  &::before,
  &::after {
    width: ${borderWidth};
    height: ${borderWidth};
    background: ${COLOURS.BELONG_BLUE};
  }
`;
